import { Notification } from '../../lib/types/models/notification/notification'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const markNotificationAsRead = (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.notifications.markNotificationAsRead.url, { id }))
    .post<Notification>()
}
